
import React from 'react'
import { ModalIcon } from '../icon/Icon'
import styled from "styled-components";


type IProps = {
  onClose: () => void;
  children:  JSX.Element;
}

export default function ModalWrapper({
  onClose,
  children
}: IProps) {
  return (

    <>
      <ModalIconWrapper
        onClick={onClose}
      >
        <ModalIcon
        />
      </ModalIconWrapper>
      {children}
    </>
  )
};


const ModalIconWrapper = styled.div`
  margin-bottom: 1rem;
  position: sticky;
  top: 0;
  display: flex;
  align-self: flex-end;
  justify-content: end;
  align-self: end;
  z-index: 9999;
`;

